// extracted by mini-css-extract-plugin
module.exports = {"container":"admin_container__15wbP","buttonBox":"admin_buttonBox__3hrKs","button":"admin_button__1iH8-","postListBox":"admin_postListBox__WiNcy"};